import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sistema_ges_integral',
  templateUrl: './sistema_ges_integral.component.html',
  styleUrls: ['./sistema_ges_integral.component.css']
})
export class Sistema_ges_integralComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
